import { Reveal, SectionHeader } from "@/components/Reveal";
import { geschichte } from "@/data/content";

const Geschichte = () => (
  <section id="geschichte" className="relative bg-fw-navy py-24 md:py-32 text-white overflow-hidden" data-testid="geschichte-section">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <SectionHeader kicker="1874 – 2026" title={geschichte.title} subtitle={geschichte.subtitle} dark testId="geschichte-header" />
      <Reveal>
        <p className="max-w-3xl font-body text-lg text-white/70 mb-16">{geschichte.intro}</p>
      </Reveal>

      <div className="relative">
        {/* Zeitstrahl-Linie */}
        <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-fw-gold/30 -translate-x-1/2" />

        <div className="space-y-14 md:space-y-24">
          {geschichte.chapters.map((c, i) => (
            <div
              key={c.no}
              className={`relative grid md:grid-cols-2 gap-6 md:gap-14 items-center ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}
              data-testid={`geschichte-chapter-${c.no}`}
            >
              {/* Punkt */}
              <div className="absolute left-4 md:left-1/2 -translate-x-1/2 z-10 h-4 w-4 rounded-full bg-fw-gold ring-4 ring-fw-navy" />

              <Reveal className="pl-12 md:pl-0 [direction:ltr]">
                <div className="group overflow-hidden border-2 border-fw-gold/60 p-2">
                  <img
                    src={c.image}
                    alt={c.title}
                    className="w-full aspect-video object-cover grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105"
                  />
                </div>
              </Reveal>

              <Reveal delay={0.1} className="pl-12 md:pl-0 [direction:ltr]">
                <span className="font-technical text-6xl md:text-8xl font-black text-stroke-gold leading-none">{c.no}</span>
                <p className="mt-2 font-technical uppercase tracking-[0.3em] text-fw-gold text-sm">{c.jahr}</p>
                <h3 className="mt-2 font-heritage text-3xl md:text-4xl text-white">{c.title}</h3>
                <p className="mt-3 font-body text-white/70 max-w-md">{c.text}</p>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Geschichte;
